/**
 * Some components have special meaning depending on their id (e.g: 'name' represents the card's title,
 * used across the system. 'startDate' represents the card's start date, used across the system as well)
 */
export const STATIC_COMPONENT_IDS = {
  NAME: 'name',
  START_DATE: 'startDate',
  SEQUENCE_NUMBER: 'sequenceNumber',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  DELETED_AT: 'deletedAt',
  ASSIGNEES: 'assignees',
  ENTITY_BATCH: 'entityBatch',
  USER_ID: 'userId',
};
